<template>
    <div class="dropdown">
    <div class="svg-profile-icon d-none btn btn-icon btn-light-success w-auto btn-clean align-items-center btn-lg px-2 mt-2" data-toggle="dropdown" data-offset="0px,0px" aria-expanded="true">
        <button class="btn p-0 ml-2" id="kt_header_mobile_topbar_toggle">
            <span class="svg-icon svg-icon-xl">
                <!--begin::Svg Icon | path:assets/media/svg/icons/General/User.svg-->
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <polygon points="0 0 24 0 24 24 0 24" />
                    <path d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
                    <path d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z" fill="#000000" fill-rule="nonzero" />
                </g>
                </svg>
                
                <!--end::Svg Icon-->
            </span>
        </button>
    </div>
        <!--begin::Toggle-->
        <div class="desktop-profile-btn btn btn-icon btn-light-success w-auto btn-clean d-inline-flex align-items-center btn-lg px-2" data-toggle="dropdown" data-offset="0px,0px" aria-expanded="true">
            <span class="text-mute font-weight-bold font-size-base mr-1  btn-dropdown">{{$t('hi')}},</span>
            <span v-if="account_type == 'admin'" class="text-dark-50 font-weight-bolder font-size-base mr-3  btn-dropdown">{{ adminName }}</span>
            <span class="text-dark-50 font-weight-bolder font-size-base mr-3  btn-dropdown">{{ capitalizeString(FullName) }}</span>
            <span class="symbol symbol-35 symbol-light-success">
                <span class="symbol-label font-size-h5 font-weight-bold  btn-dropdown" style="color: #1BC5BD !important">{{firstCharacter}}</span>
            </span>
        </div>
        <!--end::Toggle-->
        <!--begin::Dropdown-->

        <div class="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg p-0 accountDetails"  x-placement="bottom-end">
            <!--begin::Header-->
            <div v-if="['admin', 'owner', 'staff'].includes(this.$store.getters.role)">
                <router-link to="/dashboard/settings/account">
            <div class="d-flex align-items-center p-8 rounded-top">
                <!--begin::Symbol-->
                <span class="symbol symbol-35 symbol-light-success">
                    <span class="symbol-label font-size-h5 font-weight-bold">{{firstCharacter}}</span>
                </span>
                <!--end::Symbol-->
                <!--begin::Text-->
                <div v-if="account_type == 'admin'" class="text-dark m-0 flex-grow-1 ml-3  mr-3 font-size-h5">{{adminName}}</div>
                <div class="text-dark m-0 flex-grow-1 ml-3  mr-3 font-size-h5">{{capitalizeString(FirstName)}}</div>
               <i v-if="account_type != 'admin'" class="fas fa-cog"></i>
                <!--end::Text-->
            </div>
                </router-link>   
            </div>

            <div v-if="['customer-contact'].includes(this.$store.getters.role)">
                <router-link to="/shop/setting/account">
            <div class="d-flex align-items-center p-8 rounded-top">
                <!--begin::Symbol-->
                    <span class="symbol symbol-35 symbol-light-success">
                        <span class="symbol-label font-size-h5 font-weight-bold">{{firstCharacter}}</span>
                    </span>
                    <!--end::Symbol-->
                    <!--begin::Text-->
                    <div class="text-dark m-0 flex-grow-1 ml-3  mr-3 font-size-h5">{{FirstName}}</div>
                     <i class="fas fa-cog"></i> 
                    <!--end::Text-->
            </div>
                </router-link>  
            </div>
            
            <div class="separator separator-solid custom-separator"></div>
            <!--end::Header-->
            <!--begin::Nav-->
            <div class="navi navi-spacer-x-0 pt-5">
                <!--begin::Item-->
                <div class="navi-footer px-8 py-5 float-right">
                     <a @click="logout" class="btn btn-sm btn-primary font-weight-bolder py-2 px-5" :style="primaryBtnColor">{{$t('sign_out')}}</a>
                </div>
                <!--end::Footer-->
            </div>
            <!--end::Nav-->
        </div>
        <!--end::Dropdown-->
    </div>
</template>
<script>
import UserAPIService from '@/js/api/users/users';
import LoginAPIService from '@/js/api/auth/auth';


export default{
	mounted(){
        if(['admin','owner','staff','customer-contact'].includes(this.$store.state.role)){
            this.getAccountDetail();
        }
    },
	computed: {
	    FullName () {
	    	return this.FirstName + this.LastName;
		},
		firstCharacter(){
            if(this.FirstName != null && this.account_type != 'admin'){
                return this.FirstName.charAt(0).toUpperCase();
            }
            else{
                return this.adminName.charAt(0).toUpperCase();
            }

		},
        primaryBtnColor() {
            const color = ['customer-contact'].includes(this.$store.state.role) ? this.$store.state.brand_skins['shop_primary_btn_bg_color'] : '#3699FF';
            return {
                'background-color': `${color} !important`,
            };
        },
	},
	data(){
		return {
			FirstName:'',
			LastName:'',
            adminName: '',
            account_type: '',
            isSignupCompleted : false,
            access_token : localStorage.getItem("access-token"),
		}
    },
	methods:{
		getAccountDetail(e){
            let self = this
			UserAPIService.getAccountDetail(this.access_token).then((response) => {
					if(response.data.account_type == 'owner' || response.data.account_type == 'staff' || response.data.account_type == 'contact-person' || response.data.account_type == 'primary' || response.data.account_type == 'secondary' || response.data.account_type == 'admin')
					{
                        if(typeof response.data.settings.name != "undefined")
                        {
                            this.FirstName = response.data.settings.name;
                        }
                        this.account_type = response.data.account_type;
                        this.adminName = response.data.settings.username;
                        if(response.data.integration){
                            this.$store.commit('SET_INTEGRATIONS', response.data.integration);
                        }
                        if(response.data.account_type == 'staff'){
                            this.$store.commit('SET_ROLE',response.data.role);
                            this.$store.commit('SET_PERMISSIONS', response.data.permissions);
                            this.$store.commit('SET_BRAND',response.data.brand);
                            this.$store.commit('SET_BRAND_SETTINGS_LIST',response.data.brandSettings);
                        }
                        if(response.data.role == 'customer-contact'){
                            this.$store.commit('SET_BRAND',response.data.brand);
                            this.$store.commit('SET_BRAND_SETTINGS_LIST',response.data.brandSettings);
                            this.$store.commit('SET_SHOP_CUSTOMER_ID',response.data.settings.cid);
                        }
                        self.$emit('brandLogoCatcher',response.data.settings.brand_logo);
					}
			}).catch((error) => {
                 this.notify("Error Exception!",error, "error");
            });
		},
		logout(){
            this.$store.commit('SHOW_LOADER',true);
            LoginAPIService.getLogout().then((response) => {
                this.$store.dispatch('reset').then(response => {
                this.$store.commit('SHOW_LOADER',false);
                this.$intercom.shutdown();
                this.$router.push("/");
                })
            }).catch((error) => {
                this.$store.commit('SHOW_LOADER',false);
                this.notify("Error!", "Error", "error");
            })
        }
	}
};

</script>
<style scoped="">
    .accountDetails{
       position: absolute; transform: translate3d(-310px, 40px, 0px); top: 0px; left: 0px; will-change: transform;
    }
    @media(max-width: 600px){
      .dropdown-menu{
        width:75vw !important;
       }
    }

/* Media query for screens with a maximum width of 900px (mobile view) */
@media (max-width: 900px) {
    /* Show the SVG profile icon in mobile view */
    .svg-profile-icon {
        display: block !important;
    }

    /* Hide the desktop profile button in mobile view */
    .desktop-profile-btn {
        display: none !important;
    }
}
    .custom-separator{
    max-width: 290px;
    margin: auto;
    /* border-bottom: 1px solid #3699FF; */
    }

    .btn.btn-light-success {
        color: #1bc5bd;
        background-color: #c9f7f5 !important;
        border-color: transparent;
    }
    .btn.btn-light-success.focus:not(.btn-text), .btn.btn-light-success:focus:not(.btn-text), .btn.btn-light-success:hover:not(.btn-text):not(:disabled):not(.disabled) {
        color: #fff;
        background-color: #1bc5bd !important;
        border-color: transparent;
    }
    .text-mute {
    color: #b5b5c3 !important;
    }
    .topbar .topbar-item .btn.btn-icon .text-dark-50 {
        color: #7E8299 !important;
    }
    .symbol.symbol-light-success .symbol-label{
    background-color: #c9f7f5; 
    color: #1bc5bd;
    }
    .symbol.symbol-light-success .symbol-label:hover{
        background-color:  #c9f7f5 !important;
    }
</style>